


























































import {Component, Vue} from "vue-property-decorator";
import PortalMoneyInput from "@/components/common/PortalMoneyInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import SelectOption from "@/components/common/SelectOption";
import WalletService from "@/services/WalletService";
import {DepositPayload} from "@/dto/wallet/WalletDTOs";
import Application from "@/state/Application";
import {processError} from "@/utils/ComponentUtils";
import moment from "moment";

@Component({
  components: {
    PortalMoneyInput,
    PortalSelect,
    PortalDate,
    PortalTextarea,
  }
})
export default class WalletDepositModal extends Vue {
  private companyId: number | null = null;
  private clientAccountId: number | null = null;
  private sublimeAccountId: number | null = null;
  private amountCents: number | null = null;
  private date = "";
  private description = "";
  private clientAccountOptions: Array<SelectOption> = [];
  private sublimeAccountOptions: Array<SelectOption> = [];

  beforeOpen(event: any) {
    this.companyId = event.params.companyId;
    this.clientAccountOptions = event.params.clientAccountOptions || [];
    this.sublimeAccountOptions = event.params.sublimeAccountOptions || [];
    this.clientAccountId = null;
    this.sublimeAccountId = null;
    this.amountCents = null;
    this.date = moment().format("YYYY-MM-DD");
    this.description = "";
    this.$validator.reset();
  }

  closeModal() {
    this.$modal.hide("wallet-deposit-modal");
  }

  async submit() {
    const valid = await this.$validator.validateAll();
    if (!valid || !this.companyId || !this.clientAccountId || !this.sublimeAccountId || !this.amountCents || this.amountCents <= 0) {
      return;
    }
    const payload = new DepositPayload({
      clientAccountId: Number(this.clientAccountId),
      sublimeAccountId: Number(this.sublimeAccountId),
      amountCents: this.amountCents,
      date: this.date,
      description: this.description || null,
    });
    Application.startLoading();
    WalletService.deposit(this.companyId, payload).then(
        () => {
          Application.stopLoading();
          this.$emit("saved");
          this.closeModal();
        },
        err => processError(err, this),
    );
  }
}
